import React from "react";
import { base44 } from "@/api/base44Client";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import GoogleIcon from "@/components/GoogleIcon";

export default function Login() {
  const handleGoogle = () => {
    base44.auth.loginWithProvider("google", "/admin");
  };

  return (
    <AuthLayout
      icon={LogIn}
      title="Welcome back"
      subtitle="Sign in with your Google account"
    >
      <Button
        variant="outline"
        className="w-full h-12 text-sm font-medium"
        onClick={handleGoogle}
      >
        <GoogleIcon className="w-5 h-5 mr-2" />
        Continue with Google
      </Button>
      <p className="text-xs text-muted-foreground text-center mt-6">
        Access is restricted to authorized Seisfra accounts. Your account will be validated after sign-in.
      </p>
    </AuthLayout>
  );
}